export default __webpack_public_path__ + "static/media/blackboard_default_snapshot.39143aa0.png";